module.exports = __webpack_public_path__ + "static/academically-adrift-c578aeea0246573c007bd0845c11d891.jpg";